module.exports = __webpack_public_path__ + "static/media/08.98810db5.gif";